import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { StyledSubmitButton } from "../../../../../common-components/MultiSelector/Buttons/styles";
import { StyledButton } from "./styles";

type ExportButtonProps = { onClick(): void; isDisabled: boolean; isLoading: boolean };

export const ExportButton = ({ onClick, isDisabled, isLoading }: ExportButtonProps) => {
    const translate = useTranslation();
    return (
        <StyledSubmitButton
            isDisabled={isDisabled}
            isLoading={isLoading}
        >
            <StyledButton
                onClick={onClick}
                isDisabled={isDisabled}
                isLoading={isLoading}
                dataAutomation="contacts-actions-panel.export-action-button"
            >
                {translate("si.contacts_search.action.export.submit.text")}
            </StyledButton>
        </StyledSubmitButton>
    );
};
